import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEO from '@/components/feature/SEO';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import VideoSection from './components/VideoSection';
import { allVideos, categories } from '@/mocks/videos';

const homeSEO = {
  title: '棒棒TV - 电视剧全集电影大全，最新剧集热播电视剧最新电影，免费在线观看高清不卡顿',
  description: '棒棒TV汇集电视剧全集、电影大全，最新热播剧集和电影，免费在线观看，高清不卡顿免缓冲流畅播放。涵盖电视剧、电影、综艺、动漫等全品类影视内容。',
  keywords: '电视剧全集,电影大全,最新剧集,热播电视剧,最新电影,棒棒TV,免费在线观看,高清视频,不卡顿,在线影院,综艺节目,动漫在线看',
  canonicalUrl: 'https://bangbangtv.com',
  jsonLd: [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '棒棒TV',
      url: 'https://bangbangtv.com',
      description: '棒棒TV汇集电视剧全集、电影大全，最新热播剧集和电影，免费在线观看，高清不卡顿免缓冲流畅播放。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-8888',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '棒棒TV',
      url: 'https://bangbangtv.com',
      description: '棒棒TV汇集电视剧全集、电影大全，最新热播剧集和电影，免费在线观看，高清不卡顿免缓冲流畅播放。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://bangbangtv.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '棒棒TV - 首页',
      url: 'https://bangbangtv.com',
      description: '棒棒TV汇集电视剧全集、电影大全，最新热播剧集和电影，免费在线观看，高清不卡顿免缓冲流畅播放。',
      isPartOf: {
        '@type': 'WebSite',
        name: '棒棒TV',
        url: 'https://bangbangtv.com',
      },
    },
  ],
};

export default function Home() {
  const hotVideos = allVideos.filter((v) => v.isHot);
  const newVideos = allVideos.filter((v) => v.isNew);
  const tvSeries = allVideos.filter((v) => v.categorySlug === 'dianshiju');
  const movies = allVideos.filter((v) => v.categorySlug === 'dianying');
  const variety = allVideos.filter((v) => v.categorySlug === 'zongyi');
  const anime = allVideos.filter((v) => v.categorySlug === 'dongman');

  return (
    <>
      <SEO data={homeSEO} />
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroBanner />
        <CategoryNav />

        <VideoSection
          title="热门推荐"
          subtitle="全网热播，大家都在看"
          videos={hotVideos}
        />

        <VideoSection
          title="最新上线"
          subtitle="新鲜出炉，抢先观看"
          videos={newVideos}
        />

        <VideoSection
          title="电视剧"
          subtitle="热门剧集一网打尽"
          videos={tvSeries}
          viewAllLink="/category/dianshiju"
        />

        <VideoSection
          title="电影"
          subtitle="大片佳作随心看"
          videos={movies}
          viewAllLink="/category/dianying"
        />

        <VideoSection
          title="综艺"
          subtitle="欢乐时光不停歇"
          videos={variety}
          viewAllLink="/category/zongyi"
        />

        <VideoSection
          title="动漫"
          subtitle="二次元精彩世界"
          videos={anime}
          viewAllLink="/category/dongman"
        />

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-12">
          <div className="bg-background-100 rounded-xl p-6 md:p-10 text-center">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading mb-3">
              海量资源 · 高清流畅 · 免费观看
            </h2>
            <p className="text-sm md:text-base text-foreground-400 max-w-2xl mx-auto mb-6">
              棒棒TV汇集超过10万部影视作品，涵盖电视剧、电影、综艺、动漫等全品类内容。采用全球CDN加速，高清不卡顿，为您带来极致的观影体验。
            </p>
            <div className="flex items-center justify-center gap-8 md:gap-16 flex-wrap">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">5000万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-500 font-heading">4K</div>
                <div className="text-xs text-foreground-500 mt-1">超清画质</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">24h</div>
                <div className="text-xs text-foreground-500 mt-1">同步更新</div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}